import { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, Row, Col, Button, message } from 'antd';

import useAppSelector from 'hooks/useAppSelector';
import { setUserState } from 'features/userSlice';

import { patchUser } from 'apis/user';
import { User } from 'models/user/User';

interface EditRegularInfoFormProps {
  user: User;
  handleClose: (user?: User) => void;
}

function EditRegularInfoForm({ user, handleClose }: EditRegularInfoFormProps) {
  const dispatch = useDispatch();
  const { loginUser } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);

  const handleFinish = ({ givenName, familyName }: { givenName: string; familyName: string }) => {
    if (isLoading) return;
    if (user.given_name === givenName && user.family_name === familyName) handleClose();

    setIsLoading(true);
    patchUser(user.id, { given_name: givenName, family_name: familyName })
      .then((updatedUser) => {
        if (updatedUser.id === loginUser?.id) {
          dispatch(setUserState(updatedUser));
          handleClose(updatedUser);
        }
      })
      .catch((errMsg) => {
        if (errMsg) message.error(errMsg);
        handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Form disabled={isLoading} onFinish={handleFinish}>
      <Row gutter={8}>
        <Col flex="1 1 0">
          <Form.Item
            name="givenName"
            initialValue={user.given_name}
            rules={[{ required: true, message: '값을 입력해주세요' }]}
          >
            <Input size="large" placeholder="이름 (First name)" />
          </Form.Item>
        </Col>
        <Col flex="1 1 0">
          <Form.Item
            name="familyName"
            initialValue={user.family_name}
            rules={[{ required: true, message: '값을 입력해주세요' }]}
          >
            <Input size="large" placeholder="성 (Last name)" />
          </Form.Item>
        </Col>
        <Col flex={0}>
          <Button size="large" type="primary" htmlType="submit" loading={isLoading}>
            저장
          </Button>
          <Button size="large" type="text" htmlType="submit" loading={isLoading}>
            취소
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default memo(EditRegularInfoForm);
